import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';

export type AlertSeverity = 'error' | 'warning' | 'info' | 'success';

type AlertDialogProps = {
  open: boolean;
  onClose: () => void;
  message: string;
  severity?: AlertSeverity;
  title?: string;
};

export function AlertDialog({
  open,
  onClose,
  message,
  severity = 'error',
  title,
}: AlertDialogProps) {
  const getDefaultTitle = () => {
    const titles = {
      error: 'Erro',
      warning: 'Atenção',
      success: 'Sucesso',
      info: 'Informação',
    };

    return titles[severity as keyof typeof titles];
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{title ?? getDefaultTitle()}</DialogTitle>
      <DialogContent>
        <Alert severity={severity} sx={{ mt: 0.5 }}>
          {message}
        </Alert>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button variant="contained" color="primary" onClick={onClose}>
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
}
